import { FiChevronRight, FiExternalLink } from 'react-icons/fi'
import { Link } from 'react-router-dom'
import michaelOkunProfilePhoto from '@presentation/assets/images/michael-okun-profile-photo.jpg'
import ExpertProfileIntro from '@presentation/components/ui/ExpertProfileIntro'
import InstagramReelCard from '@presentation/components/ui/InstagramReelCard'
import LoadingSpinner from '@presentation/components/ui/LoadingSpinner'
import { useHomeInstagramReels } from '@presentation/hooks/useHomeInstagramReels'

const DR_MICHAEL_OKUN_REELS_ROUTE = '/dr-michael-okun-my-take'

export default function InstagramReelsSection() {
  const { reels, loading, error, refresh } = useHomeInstagramReels(3)

  return (
    <section className="box-border bg-background pt-4 pb-2 sm:pt-6 sm:pb-3 lg:pt-8 lg:pb-4">
      <div className="mx-auto flex max-w-7xl flex-col pl-8 pr-4 sm:pl-10 sm:pr-6 lg:pl-14 lg:pr-8">
        <div className="pl-2 sm:pl-4 lg:pl-5">
          <ExpertProfileIntro
            photoSrc={michaelOkunProfilePhoto}
            photoAlt="Prof. Michael Okun"
            name="Prof. Michael Okun"
            affiliation="University of Florida"
            description="A renowned neuroscientist and medical director of the Parkinson's Foundation, widely regarded as a global authority on advanced Parkinson's therapies."
          />
          <div className="flex shrink-0 items-center justify-between gap-4">
            <Link to={DR_MICHAEL_OKUN_REELS_ROUTE} className="no-underline">
              <h2 className="text-2xl font-bold tracking-tight text-blue sm:text-3xl">My Take</h2>
            </Link>
            <Link
              to={DR_MICHAEL_OKUN_REELS_ROUTE}
              aria-label="View all Prof Michael Okun My Take posts and reels"
              className="inline-flex shrink-0 items-center gap-1.5 rounded-lg border border-blue px-3 py-2 text-sm font-semibold text-blue no-underline transition-colors hover:border-blue hover:bg-blue/8"
            >
              View all
              <FiExternalLink className="size-4" aria-hidden="true" />
            </Link>
          </div>
          <div className="mt-3 h-0.5 w-full bg-blue" />
        </div>

        {loading && <LoadingSpinner className="mt-6" />}

        {error && (
          <div className="mt-6 flex flex-col items-center gap-3">
            <p className="text-center text-text-secondary">
              Unable to load Instagram content. Please try again later.
            </p>
            <button
              type="button"
              onClick={() => {
                void refresh()
              }}
              className="inline-flex rounded-lg bg-blue px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-blue/90"
            >
              Retry
            </button>
          </div>
        )}

        {!loading && !error && reels.length === 0 && (
          <p className="mt-6 text-sm font-semibold text-text-secondary">
            No Instagram content yet
          </p>
        )}

        {!loading && !error && reels.length > 0 && (
          <>
            <div className="mt-8 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
              {reels.map((reel, index) => (
                <div key={reel.uid} className={index >= 2 ? 'hidden sm:block' : undefined}>
                  <InstagramReelCard reel={reel} />
                </div>
              ))}
            </div>
            <div className="mt-3 flex shrink-0 justify-center sm:mt-4">
              <Link
                to={DR_MICHAEL_OKUN_REELS_ROUTE}
                aria-label="See more Prof Michael Okun My Take posts and reels"
                className="inline-flex items-center justify-center gap-1.5 rounded-lg bg-blue px-4 py-3 text-center text-sm font-semibold leading-tight text-white no-underline shadow-sm transition-[transform,opacity,background-color] duration-200 hover:scale-[1.02] hover:bg-blue/90 hover:opacity-90 sm:text-base"
              >
                See more Prof Michael Okun My Take
                <FiChevronRight className="size-4" aria-hidden="true" />
              </Link>
            </div>
          </>
        )}
      </div>
    </section>
  )
}
